import React from "react";
import { PetSectionRenderer } from "../sectionRenderers/PetSectionRenderer";

interface PetsTabProps {
  orderedSections: any[];
  data: any;
  handlers: any;
}

export const PetsTab: React.FC<PetsTabProps> = ({
  orderedSections,
  data,
  handlers,
}) => {
  const defaultLocalOrder = [
    "MainCarousel",
    "PetCarouselDogs",
    "VideoCarouselPets",
    "PetCarouselCats",
    "HappyParentsSection",
    "ReviewSection",
    "PetBannerFurry",
    "AdoptSection",
    "ConsultationBanner",
    "HowAdoptionWorks",
    "NewsletterBox",
  ];

  const renderingSequence =
    orderedSections.length > 0
      ? orderedSections
      : defaultLocalOrder.map((sectionType, index) => ({
          sectionId: `default-${sectionType}`,
          sectionType,
          sectionName: sectionType,
          displayOrder: index + 1,
          data: null,
        }));

  return (
    <div className="max-w-7xl mx-auto px-4 space-y-16 py-10 animate-in fade-in duration-700">
      {renderingSequence.map((section: any) => {
        if (section.isVisible === false) {
          return null;
        }

        return (
          <React.Fragment
            key={
              section.sectionId ??
              `${section.sectionType}-${section.displayOrder}`
            }
          >
            <PetSectionRenderer
              section={section}
              data={data}
              handlers={handlers}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};
